export default function NotFound() {
  return (
    <div className="flex min-h-[100dvh] w-full items-center justify-center px-6 text-center">
      <h1 className="font-display text-3xl font-semibold md:text-5xl">
        Página não encontrada
      </h1>
    </div>
  );
}
